import { render, staticRenderFns } from "./ZxCountDownEdit.vue?vue&type=template&id=3ffd62b4&scoped=true"
import script from "./ZxCountDownEdit.vue?vue&type=script&lang=js"
export * from "./ZxCountDownEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffd62b4",
  null
  
)

export default component.exports